import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Search, AccountCircle, Apps, Menu, Close } from "@mui/icons-material";
import logo from "../../images/logo3.png";
import "../../scss/layout/header.scss";

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false); // State for mobile menu

  const toggleDropdown = (menu) => {
    setDropdownOpen(dropdownOpen === menu ? null : menu);
  };

  return (
    <nav className="navbar">
      <NavLink to="/">
        <div className="navbar__logo">
          <img src={logo} alt="Hellman Logo" />
        </div>
      </NavLink>

      {/* Hamburger Menu Button */}
      <button
        className="navbar__hamburger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        {menuOpen ? <Close /> : <Menu />}
      </button>

      {/* Mobile Menu */}
      <ul className={`navbar__menu ${menuOpen ? "open" : ""}`}>
        <li
          className="navbar__item"
          onMouseEnter={() => toggleDropdown("products")}
          onMouseLeave={() => toggleDropdown(null)}
        >
          PRODUCTS
          {dropdownOpen === "products" && (
            <ul className="navbar__dropdown">
              <li>
                <NavLink to="/services/air-freight">Air Freight</NavLink>
              </li>
              <li>
                <NavLink to="/services/sea-freight">Sea Freight</NavLink>
              </li>
              <li>
                <NavLink to="/services/road-transport">Road Transport</NavLink>
              </li>
              <li>
                <NavLink to="/services/nvocc">NVOCC</NavLink>
              </li>
              <li>
                <NavLink to="/services/custom-clearance">
                  Custom Clearance
                </NavLink>
              </li>
            </ul>
          )}
        </li>

        <li>
          <NavLink to="/About">ABOUT US</NavLink>
        </li>
        <li>
          <NavLink to="/Contact">CONTACT</NavLink>
        </li>
      </ul>

      <div className="navbar__actions">
        <button className="navbar__search">
          SEARCH & FIND <Search />
        </button>
        <NavLink to={"/Login"} className="navbar__login">
          <AccountCircle className="navbar__icon" />
        </NavLink>
        <Apps className="navbar__icon" />
      </div>
    </nav>
  );
};

export default Navbar;
